<template>
  <v-app>
    <Menu />
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Menu from '@/components/admin/menuadmin/Menu.vue'
import {HTTP} from "@/axios";
export default {
  name: 'pageAll',
  components: {
    Menu,
  },
  methods: {
    checkLogIn() {
      if (this.$store.state.access_token === null) {
        this.$store.commit('logout_success')
        this.$router.push('/login')
      }
    },
    async checkRoute() {
      const config = {headers: {"Authorization": `Bearer ${this.$store.state.token}`}}
      try {
        await HTTP.post('/profile', {
          username: this.$store.state.user_data.username,
          password: this.$store.state.user_data.password
        }, config).then((res) => {
          this.$store.state.userDetail = res.data
        })
      } catch (err) {
        if (err.response.status == 401) {
          this.$store.commit('logout_success')
          await this.$router.push('/login')
        }
      }
      // product manage
      if (this.$route.path == '/stock/manage_product/productadd') {
        if (this.$store.state.userDetail.manage_product_create !== 1) {
          await this.$router.push('/stock')
        }
      }
      // warehouse stock
      if (this.$route.path == '/stock/count_warehouse/warehousecount') {
        if (this.$store.state.userDetail.count_warehouse_count === 0) {
          await this.$router.push('/stock')
        }
      }
      // wait identify
      if (this.$route.path == '/stock/verifymain') {
        if (this.$store.state.status === 1) {
          await this.$router.push('/stock/verifymain')
        }
        else {
          await this.$router.push('/stock')
        }
      }
      },
  },
  beforeMount() {
    this.checkLogIn();
  },
  watch: {
    $route() {
      this.checkRoute();
    }
  }
}
</script>
